import { ValidationErrors } from "@angular/forms";

export abstract class ValidationMessageProvider {
  public getValidationErrors(validationErrors: ValidationErrors): string[] {
    const errors = [];
    Object.keys(validationErrors).forEach((key) => {
      let error;

      switch (key) {
        case "required":
          error = this.getRequiredError();
          break;
        case "pattern":
          error = this.getPatternError();
          break;
        case "minlength":
          const minLengthMessage = validationErrors[key];
          error = this.getMinLengthError(
            minLengthMessage.requiredLength,
            minLengthMessage.actualLength
          );
          break;
        case "maxlength":
          const maxLengthMessage = validationErrors[key];
          error = this.getMaxLengthError(
            maxLengthMessage.requiredLength,
            maxLengthMessage.actualLength
          );
          break;
        case "min":
          const minMessage = validationErrors[key];
          error = this.getMinError(minMessage.max, minMessage.actual);
          break;
        case "max":
          const maxMessage = validationErrors[key];
          error = this.getMaxError(maxMessage.max, maxMessage.actual);
          break;
        case "emailformat":
          error = this.getEmailFormatError();
          break;
        case "phoneformat":
          error = this.getPatternError();
          break;
        default:
          error = this.getCustomValidatorError(key, validationErrors[key]);
          break;
      }

      errors.push(error);
    });

    return errors;
  }

  protected abstract getRequiredError(): string;

  protected abstract getPatternError(): string;

  protected abstract getMinError(min: number, actual: number): string;

  protected abstract getMaxError(max: number, actual: number): string;

  protected abstract getMinLengthError(
    requiredLength: number,
    actualLength: number
  ): string;

  protected abstract getMaxLengthError(
    requiredLength: number,
    actualLength: number
  ): string;

  protected abstract getEmailFormatError(): string;

  protected abstract getPhoneFormatError(): string;

  protected abstract getCustomValidatorError(
    validatorKey: string,
    message: any
  ): string;
}
